import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Layout, { PageHero } from "@/components/Layout";
import api, { formatApiError } from "@/lib/api";
import { COMPANY } from "@/content";

const fade = { initial: { opacity: 0, y: 18 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.45 } };

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      await api.post("/contact", form);
      setStatus({ type: "ok", msg: "Thank you. Your message has been sent and we will be in touch shortly." });
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus({ type: "err", msg: formatApiError(err.response?.data?.detail) || "Could not send. Please try again." });
    } finally {
      setSending(false);
    }
  };

  return (
    <Layout>
      <PageHero crumb={<><Link to="/">Home</Link> / Contact</>} title="Contact us" subtitle="Review our products, visit our Toronto showroom, or explore partnership opportunities." />
      <section className="section">
        <div className="wrap contact-grid">
          <motion.form className="card-panel" onSubmit={submit} {...fade} data-testid="contact-form">
            <h3 style={{ marginBottom: 20 }}>Send us a message</h3>
            {status && <div className={`form-msg ${status.type}`} data-testid="contact-status">{status.msg}</div>}
            <div className="field">
              <label>Name</label>
              <input value={form.name} onChange={upd("name")} required data-testid="contact-name" placeholder="Your name" />
            </div>
            <div className="field">
              <label>Email</label>
              <input type="email" value={form.email} onChange={upd("email")} required data-testid="contact-email" placeholder="you@email.com" />
            </div>
            <div className="field">
              <label>Subject</label>
              <input value={form.subject} onChange={upd("subject")} data-testid="contact-subject" placeholder="How can we help?" />
            </div>
            <div className="field">
              <label>Message</label>
              <textarea value={form.message} onChange={upd("message")} required data-testid="contact-message" placeholder="Write your message" />
            </div>
            <button className="btn btn-primary" disabled={sending} data-testid="contact-submit" type="submit">
              {sending ? "Sending..." : "Send message"}
            </button>
          </motion.form>

          <motion.div className="info-card" {...fade} transition={{ duration: 0.5, delay: 0.1 }}>
            <h3>Cerebral Diagnostics</h3>
            <div className="info-row"><div><b>Address</b><span>{COMPANY.address}</span></div></div>
            <div className="info-row"><div><b>Phone</b><span>{COMPANY.phone}</span></div></div>
            <div className="info-row"><div><b>Email</b><span>{COMPANY.email}</span></div></div>
            <div className="info-row"><div><b>Hours</b>{COMPANY.hours.map((h) => <span key={h}>{h}</span>)}</div></div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
